export const saveLocalStorage = (key, value) => {
    localStorage.setItem(key, value);
}
export const removeLocalStorage = (key) => {
    localStorage.removeItem(key);
}